module.exports = __webpack_public_path__ + "img/Rollins-logo.bf79d6dc.png";